import _ from "lodash";
import DateTimeUtils from "../../utils/datetime-utils";
import iterateByDay from "../../utils/datetime/iterate/iterate-by-day";
import {momentRange} from "../../convert/moment-range";
import {DateRange, MomentRange} from "moment-range";

export default class StartEndDurationUtils {

    // return array of YYYY-MM-DD strings with all dates whenwe had ANY holiday
    static getHolidaysFromEvents(events:any) {
        let res : any[] = [];
        events.map((e:any)=>{
            let current = moment(e.startDate);
            res.push(current.format("YYYY-MM-DD"));
            if (e.endDate) {
                const endDate = moment(e.endDate);
                while (current.isBefore(endDate, 'day') || current.isSame(endDate, 'day')) {
                    res.push(current.format("YYYY-MM-DD"));
                    current.add( 1,'day');
                }
            }
        });
        return _.uniq(res).sort();
    }

    static getUserWorkdays(companyId:ID, userId:ID) {
        //get workday from company user
        let rowWorkdays : any[] = [];
        if (companyId) {
            const companyUser = gd.session.companyUsers.findByCompanyAndUser(companyId, userId);
            const workWeek = companyUser ? companyUser.workWeek : gd.session.companies.get(companyId).settings.workSchedule.workWeek;
            workWeek.map((value:any,key:number)=>{if(!!value) rowWorkdays.push(key+1)});
        } else rowWorkdays = [1,2,3,4,5];

        return rowWorkdays;
    }

    static getCompanyHolidays(companyEvents:any) {
        const events = _.filter(companyEvents, e=>e.type === gd.const.event.type.COMPANY_HOLIDAY);
        return StartEndDurationUtils.getHolidaysFromEvents(events);
    }

    static getUserHolidays(userEvents:any) {
        const events = _.filter(userEvents, e=>[
            gd.const.event.type.PERSONAL_PAID_VACATION,
            gd.const.event.type.PERSONAL_NON_PAID_VACATION,
            gd.const.event.type.PERSONAL_SICK_LEAVE
        ].includes(e.type));

        return StartEndDurationUtils.getHolidaysFromEvents(events);
    }

    static calculateWorkdaysHolidaysInRange(startDate:Moment, endDate:Moment, isDateHolidayCheckCallback:any) {
        const startIsBeforeEnd = startDate.isBefore(endDate, 'days');

        const start = startIsBeforeEnd ? startDate : endDate;
        const end = startIsBeforeEnd ? endDate : startDate;

        const duration = gd.utils.numberOfWeekdaysBetween(start, end);
        const current = moment(start).subtract(1,'day');
        const days = _.times(duration, ()=>moment(current.add(1, 'day')));

        let holidays : any[] = [];
        days.map(dateMoment=>{if(isDateHolidayCheckCallback(dateMoment)) holidays.push(dateMoment)});

        const workdays = _.differenceBy(days, holidays, d=>d.format('YYYY-MM-DD'));

        return { workdays, holidays };
    }

    static calculateStartDateExcludingHolidays(startDate:Moment, targetWorkdays = -1, isDateHolidayCheckCallback:any) {
        let currentWorkdays = 0;
        const direction = targetWorkdays === 0 ? null : targetWorkdays < 0 ? 'left' : 'right';

        // find correct start date subtracting days until workday is found
        let correctedStartDate = startDate;
        // for targetWorkdays set to 0 no calculations required
        let dateIsHoliday = targetWorkdays !== 0 && isDateHolidayCheckCallback(correctedStartDate);

        switch (direction) {
            case "right":
                if (!dateIsHoliday) currentWorkdays++;
                while(dateIsHoliday || currentWorkdays < targetWorkdays) {
                    correctedStartDate = moment(correctedStartDate).add(1, 'day');
                    dateIsHoliday = isDateHolidayCheckCallback(correctedStartDate);
                    if (!dateIsHoliday) currentWorkdays++;
                }
                break;

            case "left":
                if (!dateIsHoliday) currentWorkdays--;
                while(dateIsHoliday || currentWorkdays > targetWorkdays) {
                    correctedStartDate = moment(correctedStartDate).subtract(1, 'day');
                    dateIsHoliday = isDateHolidayCheckCallback(correctedStartDate);
                    if (!dateIsHoliday) currentWorkdays--;
                }
                break;

            default: /*do nothing*/ break;
        }

        return correctedStartDate;
    }

    static calculateEndDateByWorkdayDurations(startDate: Moment, estimatedMinutes: number, getWorkdayDuration: {(dateMoment: Moment):number}) {
        let endDate                 = startDate
        let undistributedMinutes    = estimatedMinutes

        while(undistributedMinutes > 0) {
            // get current weekday duration
            const workdayDuration = getWorkdayDuration(endDate)

            // decrease left minutes by workday duration minutes
            undistributedMinutes -= workdayDuration

            // increase current weekday by 1 (to the next one)
            if (undistributedMinutes > 0) {
                endDate = moment(endDate).add(1, 'day');
            }
        }

        return endDate
    }

    static calculateEndDateExcludingHolidays(startDate:Moment, targetWorkdays:number, isDateHolidayCheckCallback:any) {
        let currentWorkdays = 0;

        //find correct end date adding days until required workdays number added
        let endDate = startDate;
        let endDateIsHoliday = isDateHolidayCheckCallback(endDate);
        if (!endDateIsHoliday) currentWorkdays++;
        while(endDateIsHoliday || currentWorkdays < targetWorkdays) {
            endDate = moment(endDate).add(1, 'day');
            endDateIsHoliday = isDateHolidayCheckCallback(endDate);
            if (!endDateIsHoliday) currentWorkdays++;
        }

        return endDate;
    }

    static calculateNewScheduleDate(newStartDate:Moment, newEndDate:Moment, scheduleDate:Moment) {
        let newScheduleDate = scheduleDate ? DateTimeUtils.dateToMoment(scheduleDate) : null;

        //see if we need to adjust schedule date
        if (!newScheduleDate || newScheduleDate.isBefore(newStartDate, 'day') || newScheduleDate.isAfter(newEndDate, 'day')) {
            //if start date is before today -> today else startDate
            if (newStartDate && newStartDate.isBefore(moment())) newScheduleDate = moment(); // today
            else                                                 newScheduleDate = newStartDate;
        }

        return newScheduleDate;
    }

    static calculateWorkdaysLag(startDate:Moment, endDate:Moment, isDateHolidayCheckCallback:any) {

        if (startDate.isSame(endDate, 'days')) return 0

        let workdays = 0;

        // we gave daterange like 2022-01-03 and 2022-01-12
        if (startDate.isBefore(endDate, 'days')) {

            iterateByDay(momentRange(startDate, endDate), (curMoment:Moment) => {
                if (!isDateHolidayCheckCallback(curMoment)) workdays++
            })

            // moment.range(startDate, endDate).by('days', moment => {
            //     if (!isDateHolidayCheckCallback(moment)) workdays++
            // })

            // it's positive and for today-tomorrow we have result 2 but lag is one day less
            workdays--

        } else {

            // we invert days
            // was 2022-01-12 till 2022-01-10
            // inverted 2022-01-10 2022-01-12
            iterateByDay(momentRange(endDate, startDate), (moment:Moment) => {
                if (!isDateHolidayCheckCallback(moment)) workdays++
            })
            // moment.range(endDate, startDate).by('days', moment => {
            //     if (!isDateHolidayCheckCallback(moment)) workdays++
            // })

            // it's positive and for today-tomorrow we have result 2 but lag is one day less
            workdays--

            // and meka it negative
            workdays = workdays * -1
        }

        return workdays
    }

    static findFirstWorkingDay(momentRange:DateRange, isDateHolidayCheckCallback:any) {

        let firstWorkingDate : any = false; //momentRange.start

        iterateByDay(momentRange, (curMoment:Moment) => {
            if (!firstWorkingDate && !isDateHolidayCheckCallback(curMoment)) {
                firstWorkingDate = moment(curMoment)
            }
        })

        if (!firstWorkingDate) firstWorkingDate = momentRange.start

        return firstWorkingDate

    }

    // by Vic - good one
    // calculateStartDateExcludingHolidays gave strange result on add 1 workday...
    // so I added this function as i m not sure how the other one is used
    static addWorkdays(date:any, numberOfWorkdays = 0, isDateHolidayCheckCallback:any) {

        if (numberOfWorkdays === 0) return moment(date)

        let currentWorkdays = 0;
        const direction = numberOfWorkdays < 0 ? 'left' : 'right';

        // find correct start date subtracting days until workday is found
        let currentDate = moment(date);
        let currentDateIsHoliday = false


        switch (direction) {
            case "right":
                while(currentWorkdays < numberOfWorkdays) {
                    currentDate = moment(currentDate).add(1, 'day');
                    if (!isDateHolidayCheckCallback(currentDate)) {
                        currentWorkdays++;
                    }
                }
                break;

            case "left":
                while(currentWorkdays > numberOfWorkdays) {
                    currentDate = moment(currentDate).subtract(1, 'day');
                    if (!isDateHolidayCheckCallback(currentDate)) {
                        currentWorkdays--
                    }
                }
                break;

            default: /*do nothing*/ break;
        }

        return currentDate;
    }


}